import nanoid from 'nanoid'
import React from 'react'
import { Field as FinalField } from 'react-final-form'
import { FieldContainer } from '../styles'
import hasError from '../utils/has-error'
import Hidden from './Hidden'
import Input from './Input'
import { Error, Label } from './styles'
import FieldType from './type'

interface Props {
  field: FieldType
}

const Field: React.FC<Props> = ({ field }) => {
  const id = nanoid()
  if (!field.validation) {
    field.validation = {}
    if (!field.validation.parse) {
      field.validation.parse = (value: any) => {
        return value ? value : null
      }
    }
  }
  let styleField: object = {
    display: field.component === Hidden || field.hide === true ? 'none' : '',
  }
  if (field.html?.type === 'checkbox' && !field.hide) {
    styleField = { display: 'flex', flexDirection: 'row-reverse', justifyContent:'flex-end'}
  }

  return (
    <FieldContainer
      style={styleField}
      size={field.size}
      className="field-container"
    >
      <FinalField
        validateFields={field.validateFields ? field.validateFields : []}
        name={field.name}
        {...field.validation}
      >
        {({ input, meta }) => {
          const C = field.component || Input
          const error = hasError(meta)

          return (
            <>
              {field.data.label && (
                <Label
                  htmlFor={id}
                >{field.data.label}</Label>
              )}

              <C
                id={id}
                input={input}
                meta={meta}
                data={field.data}
                html={field.html}
              />

              {!!error && <Error
                className="validation-error"
              >{error}</Error>}
            </>
          )
        }}
      </FinalField>
    </FieldContainer>
  )
}

export default Field
